import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {WARNING_THEMES} from './types';
import css from './index.styl?inline';
import {template} from './template';

interface MPWarningAttrs {
  'body-text': string;
  'cta-href': string;
  'cta-text': string;
  'header-text': string;
  theme: WARNING_THEMES;
}

export class MPWarning extends Component<EmptyObj, MPWarningAttrs> {
  static get attrsSchema(): AttrsSchema<MPWarningAttrs> {
    return {
      ...super.attrsSchema,
      'body-text': `string`,
      'cta-href': `string`,
      'cta-text': `string`,
      'header-text': `string`,
      theme: {type: `string`, default: WARNING_THEMES.DEFAULT, enum: Object.values(WARNING_THEMES)},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleCtaClick: (ev: MouseEvent) => {
          ev.preventDefault();
          this.dispatchEvent(new CustomEvent(`ctaClick`));
        },
      },
    };
  }
}

export const WarningEl = defineAndMakeJsxFactory(`mp-warning`, MPWarning);
